module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 156.d090cc07.png";